import React, { Component } from 'react';
import FileUploader from './../../../commons/FileUploader.js';
import DownloadFile from './../../../commons/DownloadFile.js';

export default class RejectPurchaseReturn extends Component {
	render(){
		return(
			<div className="dump-ingestion-wrapper">
				<div className="white-box">
					<div className="page-header-title">
						Reject Purchase Return
					</div>
					<div> 
						<DownloadFile title="Download Reject Purchase Return Template" url="ingest/inventory/transfer/item/template"/>
					</div>
					<div className="top-thirty">
						<FileUploader url="ingest/inventory/purchase-returns/reject"/>
					</div>
				</div>
			</div>);
	}
}


// WEBPACK FOOTER //
// ./src/screens/PurchaseReturn/Components/RejectPurchaseReturn.js